export const Interactions = {
  FieldUpdate: 'fields-update',
};
